import React from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';

const AccessManagement = ({ nestedRoutes }) => {
  return (
    <Routes>
      {nestedRoutes.map(({ path, component, ...rest }) => (
        <Route key={path} path={path} element={component} {...rest} />
      ))}
      <Route path="/" element={<Navigate to="users" replace />} />
    </Routes>
  );
};

export default AccessManagement;
